/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function EmptyScreenwithButton({ setAddResourcePopup, addResourcePopup, searchValue }) {
    return (
        <div className="w-full flex flex-col justify-center items-center h-customh" style={{ height: 'calc(100vh - 230px' }}>
            <img src="/images/Group8022.svg" alt="icon" />
            <p className="text-lg font-normal text-[#15090E] mt-2">
                It seems like there aren't any
                {' '}
                <span className="text-[#ED1C24]">Resources</span>
                {' '}
                {searchValue === '' ? 'added to view!' : 'under the searched term'}
            </p>
            {searchValue === '' && (
                <div className="flex justify-center mt-8">
                    <button
                        type="button"
                        className="w-[160px] bg-[#555259] py-2.5 rounded-lg font-semibold text-xs2 text-white"
                        onClick={() => setAddResourcePopup(true)}
                    >
                        Add New
                    </button>
                </div>
            )}
        </div>
    );
}

export default EmptyScreenwithButton;
